module.exports = __webpack_public_path__ + "static/media/SCR007.a3504f18.mp3";